var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.master
    ? _c(
        "v-card",
        { staticClass: "mb-1", attrs: { flat: "" } },
        [
          _c("v-switch", {
            staticClass: "mt-1",
            attrs: { label: "Locked", color: "success", "hide-details": "" },
            model: {
              value: _vm.prop_locked,
              callback: function ($$v) {
                _vm.prop_locked = $$v
              },
              expression: "prop_locked",
            },
          }),
          _c("v-switch", {
            staticClass: "mt-1",
            attrs: { label: "Enabled", color: "success", "hide-details": "" },
            model: {
              value: _vm.prop_enabled,
              callback: function ($$v) {
                _vm.prop_enabled = $$v
              },
              expression: "prop_enabled",
            },
          }),
        ],
        1
      )
    : _c(
        "v-card",
        { staticClass: "mb-5", attrs: { flat: "" } },
        [
          _c("v-switch", {
            attrs: { label: "Enabled", color: "success", "hide-details": "" },
            model: {
              value: _vm.prop_enabled,
              callback: function ($$v) {
                _vm.prop_enabled = $$v
              },
              expression: "prop_enabled",
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }